import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

// Abhivadhi (Gothram) data - inlined for standalone use
const abhivadhi = [{"Sno":37,"Gothram":"Aabasthamba","Pravaram":"Aangirasa, Bharhaspathya, Bharatwaja"},{"Sno":79,"Gothram":"Aachvalaayana","Pravaram":"Vaasishta, Aindrapramatha, Aabarathvasasya"},{"Sno":66,"Gothram":"AagamarshaNa","Pravaram":"Vaiswamithra, AagamarshaNa, Kausika"},{"Sno":102,"Gothram":"Aagasthi","Pravaram":"Agasthya, Maahendra, Maayobhuva"},{"Sno":14,"Gothram":"AartishENa","Pravaram":"Bhargava, AarttisheNa, AnUpa"},{"Sno":15,"Gothram":"Aaswalaayana","Pravaram":"Bhargava, Vaadhyaksha, Daivadaasa"},{"Sno":48,"Gothram":"Aathreya","Pravaram":"Aathreya, Aarsanaanasa, syaavaachva"},{"Sno":60,"Gothram":"Aathreya","Pravaram":"Aathreya, Aarsanaanasa, syaavaachva"},{"Sno":38,"Gothram":"Aayaasya","Pravaram":"Aangirassa, Aayaasya, Gauthama"},{"Sno":103,"Gothram":"Agasthi","Pravaram":"Agasthya, Dhradyavrutha, Aidhmavaaha"},{"Sno":100,"Gothram":"Agasthya","Pravaram":"Agasthya - Ekarisheya"},{"Sno":99,"Gothram":"Asitha","Pravaram":"Kaasyapa, Aavathsaara, Aasitha"},{"Sno":50,"Gothram":"Athri","Pravaram":"Aathreya, Aarsanaanasa, syaavaachva"},{"Sno":13,"Gothram":"Avada","Pravaram":"Bhargava, Aurva, Jamadagnya"},{"Sno":29,"Gothram":"Bharatwaja","Pravaram":"Aangirasa, Bhaarhaspathya, Bharatwaja"},{"Sno":83,"Gothram":"Bhodayana","Pravaram":"Vaasishta, Aathreya, JaadhookarNya"},{"Sno":25,"Gothram":"Gauthama","Pravaram":"Aangirasa, Aayarsaya, Gauthama"},{"Sno":36,"Gothram":"Haritha","Pravaram":"Aangirasa, Ambarisha, Yauvanaachva"},{"Sno":78,"Gothram":"Haritha","Pravaram":"Vaasishta - Ekarsheya"},{"Sno":2,"Gothram":"Jaabaali","Pravaram":"Bhargava, Vaithahavya, Raivasa"},{"Sno":3,"Gothram":"Jaamadagnya","Pravaram":"Bhargava, Aurva, jamadagnya"},{"Sno":1,"Gothram":"Jamadagni","Pravaram":"Bhargava, Syavana, Aabnavaana"},{"Sno":92,"Gothram":"Kaasyapa","Pravaram":"Kaasyapa, Aasitha, Daivala"},{"Sno":17,"Gothram":"Kaathyaayana","Pravaram":"Bhargava, AartishENa, AnUpa"},{"Sno":45,"Gothram":"Kaundinya","Pravaram":"Aangirasa, Bharhaspathya, Bharatwaja"},{"Sno":74,"Gothram":"Kaundinya","Pravaram":"Vaasishta, MaithravaruNa, Kaundinya"},{"Sno":71,"Gothram":"Kausika","Pravaram":"Vaiswamithra, Salangayana, Kausika"},{"Sno":43,"Gothram":"Kuthsa","Pravaram":"Aangirasa, Ambareesha, Yauvanaachva"},{"Sno":75,"Gothram":"Parasara","Pravaram":"Vaasishta, saakthya, Paarasarya"},{"Sno":89,"Gothram":"Saandilya","Pravaram":"Kaasyapa, Aavathsaara, Saandilya"},{"Sno":9,"Gothram":"Srivathsa","Pravaram":"Bhargava, Syavana, Aapnavana, Aurva, Jamadagya"},{"Sno":76,"Gothram":"Vaasishta","Pravaram":"Vaasishta, Aindrapramatha, Aabarathvasasya"},{"Sno":8,"Gothram":"Vaithahavya","Pravaram":"Bhargava, Vaithahavya, Saavethasa"},{"Sno":32,"Gothram":"Vathsa","Pravaram":"Aangirasa, Bhaarhaspathya, Bharatwaja, Sainya, Gargya"},{"Sno":86,"Gothram":"Vishvaamithra","Pravaram":"Vaiswamithra, AagamarshaNa, Kausika"}];

const T = { bg:'#f0f5e8', cream:'#fffef0', greenDk:'#1b5e20', maroon:'#6d1b1b', orange:'#e65100', border:'#c8e6c9', header:'linear-gradient(135deg,#090b72,#1a237e)', success:'#2e7d32', danger:'#c62828', warning:'#f57f17' };


const STARS = [
  {value:1,name:'அஸ்வினி'},{value:2,name:'பரணி'},{value:3,name:'கார்த்திகை'},{value:4,name:'ரோகிணி'},
  {value:5,name:'ம்ருகசீர்ஷம்'},{value:6,name:'திருவாதிரை'},{value:7,name:'புனர்பூசம்'},{value:8,name:'பூசம்'},
  {value:9,name:'ஆயில்யம்'},{value:10,name:'மகம்'},{value:11,name:'பூரம்'},{value:12,name:'உத்ரம்'},
  {value:13,name:'ஹஸ்தம்'},{value:14,name:'சித்திரை'},{value:15,name:'ஸ்வாதி'},{value:16,name:'விசாகம்'},
  {value:17,name:'அநுஷம்'},{value:18,name:'கேட்டை'},{value:19,name:'மூலம்'},{value:20,name:'பூராடம்'},
  {value:21,name:'உத்ராடம்'},{value:22,name:'திருவோணம்'},{value:23,name:'அவிட்டம்'},{value:24,name:'சதயம்'},
  {value:25,name:'பூரட்டாதி'},{value:26,name:'உத்ரட்டாதி'},{value:27,name:'ரேவதி'}
];

const STANDARD_NOTE = 'குறிப்பு: ஒவ்வொரு மாசிகத்திற்கும் முதல்நாள் ஸோதகும்பம் பண்ணவேண்டும்';

// ═══════════════════════ SHASTRA OONAM FILTERS ═══════════════════════
// Source: ஸ்ம்ருதிமுக்தாபலம் - ஸ்ராத்த காண்டம் பூர்வபாகம்
const OONAM_FILTER_DEFS = [
  { id: 'badThithi', label: 'திதி தவிர்', desc: 'ப்ரதமா,ஷஷ்டி,ஏகாதசி,சதுர்த்தி,அமா' },
  { id: 'friday', label: 'வெள்ளி தவிர்' },
  { id: 'tuesday', label: 'செவ்வாய் தவிர்' },
  { id: 'saturday', label: 'சனி தவிர்' },
  { id: 'badStar', label: 'நக்ஷத்ர தவிர்', desc: 'க்ருத்திகா,ஆயில்யா,பூரம்,பூராடம்,பூரட்டாதி,கேட்டை,மூலம்' },
  { id: 'karthaStar', label: 'கர்த்தா நக்ஷ தவிர்' },
  { id: 'dwipushkaram', label: 'த்விபுஷ்கரம் தவிர்', desc: 'பத்ரா திதி+த்ரிபாத நக்ஷ' },
  { id: 'tripushkaram', label: 'த்ரிபுஷ்கரம் தவிர்', desc: 'பத்ரா+பாபவாரம்+த்ரிபாத நக்ஷ' },
];
const BAD_THITHI_NAMES = ['ப்ரதமை', 'ஷஷ்டி', 'ஏகாதசி', 'சதுர்த்தி', 'அமாவாசை', 'அமாவாசு', 'பௌர்ணமி'];
const BAD_STAR_NAMES = ['க்ருத்திகை', 'கார்த்திகை', 'ஆயில்யம்', 'பூரம்', 'பூராடம்', 'பூரட்டாதி', 'கேட்டை', 'மூலம்'];
const BHADRA_THITHI_NAMES = ['த்விதீயை', 'ஸப்தமி', 'த்வாதசி'];
const TRIPADHA_STAR_NUMS = [3, 7, 12, 16, 21, 25]; // க்ருத்திகை, புனர்பூசம், உத்ரம், விசாகம், உத்ராடம், பூரட்டாதி
const DEFAULT_OONAM_FILTERS = {};
OONAM_FILTER_DEFS.forEach(f => DEFAULT_OONAM_FILTERS[f.id] = true);

const TAMIL_MONTH_MAP = {
  'Chittirai':'சித்திரை','Chiththirai':'சித்திரை','Vaikasi':'வைகாசி','Vaigaasi':'வைகாசி',
  'Aani':'ஆனி','Aadi':'ஆடி','Aavani':'ஆவணி','Purattasi':'புரட்டாசி','Purattaasi':'புரட்டாசி',
  'Aippasi':'ஐப்பசி','Iyppasi':'ஐப்பசி','Karthigai':'கார்த்திகை','Kaarthigai':'கார்த்திகை',
  'Margazhi':'மார்கழி','Maargazhi':'மார்கழி','Thai':'தை','Masi':'மாசி','Maasi':'மாசி',
  'Panguni':'பங்குனி'
};

// ═══════════════════════ UTILITY FUNCTIONS ═══════════════════════
function fmtDate(dateStr) {
  if (!dateStr || dateStr === '—') return '—';
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  return `${String(d.getDate()).padStart(2,'0')}.${String(d.getMonth()+1).padStart(2,'0')}.${d.getFullYear()}`;
}

function formatToYMD(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return '';
  return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
}

function convertTo24HrDecimal(h, m, p) {
  let hr = h;
  if (p === 'AM' && h === 12) hr = 0;
  else if (p === 'PM' && h !== 12) hr = h + 12;
  return hr + (m / 100);
}

function sameDay(d1, d2) {
  return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
}

function findRecByDate(data, date) {
  return data.find(r => { const rd = new Date(r.EnglishDate); return sameDay(rd, date); }) || null;
}

function calcAparahnaOverlap(rec, thithiName) {
  const th1 = rec.ThithiNameInTamil || '';
  const th2 = rec.Thithi2NameInTamil || '';
  const isTh1 = th1.includes(thithiName);
  const isTh2 = th2.includes(thithiName);
  if (!isTh1 && !isTh2) return 0;
  const sunrise = rec.SuryaUdhayam || 6;
  const srHr = Math.floor(sunrise);
  const srMin = Math.round((sunrise - srHr) * 100);
  const srDec = srHr + srMin / 60;
  const kala = 12 / 5;
  const apStart = srDec + 2 * kala;
  const apEnd = srDec + 3 * kala;
  const thDur = rec.ThithiDuration || 0;
  const tdHr = Math.floor(thDur);
  const tdMin = Math.round((thDur - tdHr) * 100);
  const th1End = tdHr + tdMin / 60;
  if (isTh1) return Math.max(0, Math.min(th1End, apEnd) - Math.max(srDec, apStart));
  else return Math.max(0, Math.min(30, apEnd) - Math.max(th1End, apStart));
}

// Abbreviation map for thithi names (used in PDF to save space)
const THITHI_ABBR = {
  'ப்ரதமை':'ப்ர','த்விதீயை':'த்வி','த்ருதீயை':'த்ரு','சதுர்த்தி':'சது','பஞ்சமி':'பஞ்',
  'ஷஷ்டி':'ஷஷ்','ஸப்தமி':'ஸப்','அஷ்டமி':'அஷ்','நவமி':'நவ','தசமி':'தச',
  'ஏகாதசி':'ஏகா','த்வாதசி':'த்வா','த்ரயோதசி':'த்ரயோ','சதுர்த்தசி':'சதுர்','அமாவாசை':'அமா',
  'பௌர்ணமி':'பௌர்','பூர்ணிமா':'பூர்'
};
function abbrThithi(name) {
  if (!name) return '';
  let s = name;
  for (const [full, abbr] of Object.entries(THITHI_ABBR)) { s = s.replace(full, abbr); }
  return s;
}

function makeCandidate(rec, thithiName, opts = {}) {
  const th1 = rec.ThithiNameInTamil || '';
  const isTh1 = th1.includes(thithiName);
  const position = isTh1 ? 'end' : 'start';
  const td = rec.ThithiDuration || 0;
  const tdH = Math.floor(td);
  const tdM = Math.round((td - tdH) * 100);
  const th1EndStr = tdH + '.' + String(tdM).padStart(2, '0');
  const pakPrefix = rec.PakshamNameInTamil === 'க்ருஷ்ண' ? 'கி. ' : 'சு. ';
  // DB ShraadhdhaThithi for verification
  const dbShPak = (rec.ShraadhdhaPakshamNameInTamil || '').trim();
  const dbShName = (rec.ShraadhdhaThithiNameInTamil || '').trim();
  const dbShradhThithi = dbShPak && dbShName ? dbShPak + ' ' + dbShName : (dbShName || '');
  return {
    engDate: fmtDate(rec.EnglishDate),
    rawDate: rec.EnglishDate,
    dayName: rec.DayNameInTamil,
    th1Name: pakPrefix + (rec.ThithiNameInTamil || ''),
    th1End: th1EndStr,
    th2Name: rec.Thithi2NameInTamil ? pakPrefix + rec.Thithi2NameInTamil : '',
    starInfo: rec.NakshatraNameInTamil + (rec.NakshatraNazhigai ? '-' + rec.NakshatraNazhigai.toFixed(2) : ''),
    selected: false,
    position,
    thithiLabel: thithiName + (position === 'start' ? ' தொடக்கம் ' : ' முடிவு ') + th1EndStr,
    dbShradhThithi,  // DB verification field
    source: opts.source || 'computed',
    selectionReason: opts.reason || '',
    rejectionReason: opts.rejectionReason || ''
  };
}

// ═══════════════════════ CSV PARSER ═══════════════════════
async function loadCSVFiles() {
  const files = ['/data/plavanga-2027-data-final.csv', '/data/keelaka-2028-data-final.csv'];
  const numFields = ['TamilDate','TamilMonthNumber','TamilYearNumber','ThithiNumber','Thithi2Number','NakshatraNumber','ThithiDuration','NakshatraDuration','ThithiNazhigai','NakshatraNazhigai','SuryaUdhayam'];
  const rows = [];
  for (const file of files) {
    try {
      const res = await axios.get(file, { responseType: 'text' });
      const text = res.data;
      if (!text) continue;
      const lines = text.split('\n').filter(l => l.trim());
      const header = lines[0].replace(/^\uFEFF/, '').split(',').map(h => h.trim());
      for (let i = 1; i < lines.length; i++) {
        const cols = lines[i].split(',');
        const obj = {};
        header.forEach((h, idx) => {
          const v = (cols[idx] || '').trim();
          if (numFields.includes(h)) obj[h] = v ? parseFloat(v) : 0;
          else obj[h] = v;
        });
        rows.push(obj);
      }
    } catch (e) { console.warn('CSV load error for', file, e); }
  }
  return rows;
}

// ═══════════════════════════════════════════════════════════
// BUILD OONAM CANDIDATE BLOCK (with full Shastra checks)
// ═══════════════════════════════════════════════════════════
function buildOonamBlock(label, dayRange, deathDate, startDay, endDay, panchangamData, karthaStarNumber, standardStart, standardEnd) {
  const karthaStarName = STARS.find(s => s.value === karthaStarNumber)?.name || '';
  const rangeStart = new Date(deathDate); rangeStart.setDate(rangeStart.getDate() + startDay);
  const rangeEnd = new Date(deathDate); rangeEnd.setDate(rangeEnd.getDate() + endDay);
  // Standard range boundaries for exemption marking
  const stdStart = standardStart || startDay;
  const stdEnd = standardEnd || endDay;
  const stdStartDate = new Date(deathDate); stdStartDate.setDate(stdStartDate.getDate() + stdStart);
  const stdEndDate = new Date(deathDate); stdEndDate.setDate(stdEndDate.getDate() + stdEnd);
  const candidates = [];
  for (const rec of panchangamData) {
    const recDate = new Date(rec.EnglishDate);
    if (recDate < rangeStart || recDate > rangeEnd) continue;
    const dayCount = Math.round((recDate.getTime() - deathDate.getTime()) / 86400000);
    const day = rec.DayNameInTamil || '';
    const th1 = rec.ThithiNameInTamil || '';
    const star = rec.NakshatraNameInTamil || '';
    const starNum = rec.NakshatraNumber || 0;

    // Day checks
    const isTue = day.includes('செவ்வாய்');
    const isFri = day.includes('வெள்ளி');
    const isSat = day.includes('சனி');
    const isSun = day.includes('ஞாயிறு');
    const isKarthaStar = karthaStarName && star.includes(karthaStarName);
    const isBadThithi = BAD_THITHI_NAMES.some(t => th1.includes(t));
    const isBadStar = BAD_STAR_NAMES.some(s => star.includes(s));
    const isBhadra = BHADRA_THITHI_NAMES.some(t => th1.includes(t));
    const isTripadha = TRIPADHA_STAR_NUMS.includes(starNum);
    const isDwipush = isBhadra && isTripadha;
    const isPapaVaaram = isTue || isSat || isSun;
    const isTripush = isBhadra && isPapaVaaram && isTripadha;
    // Exemption: outside standard range (before or after)
    const isExemption = recDate < stdStartDate || recDate > stdEndDate;

    const pakPrefix = rec.PakshamNameInTamil === 'க்ருஷ்ண' ? 'கி. ' : 'சு. ';
    const checks = [
      { id: 'badThithi', label: 'நல்ல திதி', pass: !isBadThithi },
      { id: 'friday', label: 'வெள்ளி அல்ல', pass: !isFri },
      { id: 'tuesday', label: 'செவ்வாய் அல்ல', pass: !isTue },
      { id: 'saturday', label: 'சனி அல்ல', pass: !isSat },
      { id: 'badStar', label: 'நல்ல நக்ஷ', pass: !isBadStar },
      { id: 'karthaStar', label: 'கர்த்தாநக்ஷ அல்ல', pass: !(isKarthaStar && karthaStarName) },
      { id: 'dwipushkaram', label: 'த்விபுஷ் இல்லை', pass: !isDwipush },
      { id: 'tripushkaram', label: 'த்ரிபுஷ் இல்லை', pass: !isTripush },
    ];
    candidates.push({
      engDate: fmtDate(rec.EnglishDate), rawDate: rec.EnglishDate,
      dayName: rec.DayNameInTamil, tamilDate: rec.TamilDate, tamilMonth: rec.MonthNameInTamil,
      thithiInfo: pakPrefix + rec.ThithiNameInTamil + (rec.ThithiNazhigai ? '-' + rec.ThithiNazhigai?.toFixed(2) : ''),
      starInfo: rec.NakshatraNameInTamil + (rec.NakshatraNazhigai ? '-' + rec.NakshatraNazhigai?.toFixed(2) : ''),
      selected: false, checks, isExemption, dayCount
    });
  }
  return { label, dayRange, candidates };
}


// ═══════════════════════════════════════════════════════════
// BUILD MASIKAM BLOCKS
// ═══════════════════════════════════════════════════════════
function buildMasyamBlocks(deathDate, thithiName, personPaksham, panchangamData, csvData, maxDays = 420) {
  const blocks = [];
  const startDate = new Date(deathDate); startDate.setDate(startDate.getDate() + 1);
  const endDate = new Date(deathDate); endDate.setDate(endDate.getDate() + maxDays);
  const targetPak = personPaksham;

  // Collect matching dates
  const matchDates = [];
  for (const pRec of panchangamData) {
    const recDate = new Date(pRec.EnglishDate);
    if (recDate <= startDate || recDate > endDate) continue;
    const pDateStr = formatToYMD(pRec.EnglishDate);
    const csvRec = csvData.find(c => formatToYMD(c.EnglishDate) === pDateStr);
    if (csvRec) {
      const shName = (csvRec.ShraadhdhaThithiNameInTamil || '').trim();
      const shPak = (csvRec.ShraadhdhaPakshamNameInTamil || '').trim();
      const daySpec = (csvRec.DaySpecialityInTamil || '').trim();
      if (shName === thithiName && shPak === targetPak) { matchDates.push({ rec: csvRec, isAdhika: false, note: '', source: 'csv' }); continue; }
      if (shName === 'சூன்ய திதி' && daySpec.includes('அதிக திதி-' + thithiName)) { matchDates.push({ rec: csvRec, isAdhika: true, note: daySpec, source: 'csv' }); continue; }
    } else {
      // USE ShraadhdhaThithiNameInTamil — the aparahna thithi, NOT ThithiNameInTamil
      const shradhdha = (pRec.ShraadhdhaThithiNameInTamil || '').trim();
      if (!shradhdha || shradhdha === 'சூன்ய திதி' || shradhdha === 'சூன்யதிதி' || shradhdha === 'அதிதி') continue;
      // The local JSON stores ShraadhdhaThithi as "க்ருஷ்ண ப்ரதமை" (with paksham prefix)
      // Match: shradhdha must contain the thithiName AND the targetPak
      const matchesThithi = shradhdha.includes(thithiName);
      const matchesPaksham = shradhdha.includes(targetPak);
      if (matchesThithi && matchesPaksham) {
        matchDates.push({ rec: pRec, isAdhika: false, note: '', source: 'computed' });
      }
    }
  }
  matchDates.sort((a, b) => new Date(a.rec.EnglishDate).getTime() - new Date(b.rec.EnglishDate).getTime());

  // Group into cycles (consecutive days within 3-day gap)
  const cycles = [];
  let currentCycle = [];
  for (const entry of matchDates) {
    if (currentCycle.length > 0) {
      const lastDate = new Date(currentCycle[currentCycle.length - 1].rec.EnglishDate);
      const thisDate = new Date(entry.rec.EnglishDate);
      const gap = Math.round((thisDate.getTime() - lastDate.getTime()) / 86400000);
      if (gap <= 3) { currentCycle.push(entry); continue; }
      else { cycles.push(currentCycle); currentCycle = []; }
    }
    currentCycle.push(entry);
  }
  if (currentCycle.length > 0) cycles.push(currentCycle);

  // Mark adhika in same Tamil month
  for (let i = 1; i < cycles.length; i++) {
    const prev = cycles[i - 1][0].rec;
    const curr = cycles[i][0].rec;
    if (prev.TamilMonthNumber === curr.TamilMonthNumber && prev.TamilYearNumber === curr.TamilYearNumber) {
      if (!cycles[i - 1].some(e => e.isAdhika) && !cycles[i].some(e => e.isAdhika)) {
        cycles[i - 1].forEach(e => e.isAdhika = true);
      }
    }
  }

  // Build blocks
  let masyamCounter = 2;
  for (const cycle of cycles) {
    if (masyamCounter > 12 && !cycle.some(e => e.isAdhika)) break;
    const regularEntries = cycle.filter(e => !e.isAdhika);
    const adhikaEntries = cycle.filter(e => e.isAdhika);
    if (regularEntries.length > 0 && masyamCounter <= 12) {
      const entrySource = regularEntries[0].source || 'computed';
      const candidates = regularEntries.map(e => makeCandidate(e.rec, thithiName, {
        source: e.source || 'computed',
        reason: e.source === 'csv' ? 'CSV சரிபார்க்கப்பட்ட தேதி — அபராஹ்ண வ்யாப்தி உறுதிசெய்யப்பட்டது' : 'பஞ்சாங்க தரவுப்படி — திதி + பக்ஷம் பொருத்தம்'
      }));

      // Add adjacent days if only one candidate
      if (regularEntries.length === 1) {
        const mainRec = regularEntries[0].rec;
        const mainDate = new Date(mainRec.EnglishDate);
        const prevDate = new Date(mainDate); prevDate.setDate(prevDate.getDate() - 1);
        const prevRec = findRecByDate(panchangamData, prevDate) || findRecByDate(csvData, prevDate);
        if (prevRec) {
          const th1 = prevRec.ThithiNameInTamil || ''; const th2 = prevRec.Thithi2NameInTamil || '';
          if (th1.includes(thithiName) || th2.includes(thithiName)) {
            const overlap = calcAparahnaOverlap(prevRec, thithiName);
            if (overlap > 0) candidates.unshift(makeCandidate(prevRec, thithiName, { source: 'computed', reason: 'முந்தைய நாள் — திதி தொடக்கம், அபராஹ்ண வ்யாப்தி உள்ளது', rejectionReason: 'முந்தைய நாள் — அபராஹ்ண வ்யாப்தி குறைவாக இருக்கலாம்' }));
          }
        }
        const nextDate = new Date(mainDate); nextDate.setDate(nextDate.getDate() + 1);
        const nextRec = findRecByDate(panchangamData, nextDate) || findRecByDate(csvData, nextDate);
        if (nextRec) {
          const th1 = nextRec.ThithiNameInTamil || ''; const th2 = nextRec.Thithi2NameInTamil || '';
          if (th1.includes(thithiName) || th2.includes(thithiName)) {
            const overlap = calcAparahnaOverlap(nextRec, thithiName);
            if (overlap > 0) candidates.push(makeCandidate(nextRec, thithiName, { source: 'computed', reason: 'அடுத்த நாள் — திதி முடிவு, அபராஹ்ண வ்யாப்தி உள்ளது', rejectionReason: 'அடுத்த நாள் — முதன்மை தேதி அல்ல' }));
          }
        }
      }
      candidates.forEach(c => c.selected = false);
      const csvDate = fmtDate(regularEntries[0].rec.EnglishDate);
      const csvIdx = candidates.findIndex(c => c.engDate === csvDate);
      if (csvIdx >= 0) { candidates[csvIdx].selected = true; candidates[csvIdx].selectionReason = (entrySource === 'csv' ? '🔒 CSV சரிபார்க்கப்பட்டது' : '✓ அபராஹ்ண வ்யாப்தி') + ' — தானியங்கி தேர்வு'; }
      else if (candidates.length > 0) { candidates[0].selected = true; candidates[0].selectionReason = '✓ முதன்மை தேதி — தானியங்கி தேர்வு'; }
      blocks.push({ label: `${masyamCounter}ம் மாஸ்யம்`, isAdhika: false, candidates });
      masyamCounter++;
    }
    for (const ae of adhikaEntries) {
      const c = makeCandidate(ae.rec, thithiName);
      c.selected = true;
      blocks.push({ label: 'அதிக மாஸ்யம்', isAdhika: true, candidates: [c] });
    }
  }
  return blocks;
}

// ═══════════════════════════════════════════════════════════
// BUILD VARSHAAPTHEEKAM
// ═══════════════════════════════════════════════════════════
function buildVarshaBlock(deathRecord, thithiName, personPaksham, panchangamData, csvData) {
  if (!deathRecord) return null;
  const dtm = deathRecord.TamilMonthNumber;
  const dty = deathRecord.TamilYearNumber;
  const targetPak = personPaksham;
  const vCands = [];

  // CSV first
  for (const rec of csvData) {
    if (Number(rec.TamilMonthNumber) !== dtm || Number(rec.TamilYearNumber) !== dty + 1) continue;
    const shName = (rec.ShraadhdhaThithiNameInTamil || '').trim();
    const shPak = (rec.ShraadhdhaPakshamNameInTamil || '').trim();
    if (shName === thithiName && shPak === targetPak) vCands.push(makeCandidate(rec, thithiName));
  }
  // Fallback to JSON — use ShraadhdhaThithiNameInTamil (aparahna thithi)
  if (vCands.length === 0) {
    for (const rec of panchangamData) {
      if (rec.TamilMonthNumber !== dtm || rec.TamilYearNumber !== dty + 1) continue;
      const shradhdha = (rec.ShraadhdhaThithiNameInTamil || '').trim();
      if (!shradhdha || shradhdha === 'சூன்ய திதி' || shradhdha === 'சூன்யதிதி' || shradhdha === 'அதிதி') continue;
      if (shradhdha.includes(thithiName) && shradhdha.includes(targetPak)) {
        vCands.push(makeCandidate(rec, thithiName));
      }
    }
  }
  if (vCands.length > 0) { vCands[0].selected = true; return { label: 'வருஷாப்தீகம்', isAdhika: false, candidates: vCands }; }
  return null;
}

// ═══════════════════════════════════════════════════════════
// BUILD FINAL SCHEDULE
// ═══════════════════════════════════════════════════════════
function buildSchedule(deathDate, oonamBlocks, masyamBlocks, varshaBlock, panchangamData, csvData) {
  const rows = [];
  let slNo = 1;
  const makeRow = (label, rec, type) => {
    if (!rec) return { slNo: slNo++, label, type, engDate: '—', dayName: '—', tamilMonth: '—', tamilDate: 0, thithiInfo: '—', starInfo: '—', notes: '' };
    const days = Math.round((new Date(rec.EnglishDate).getTime() - deathDate.getTime()) / 86400000);
    const pakPrefix = rec.PakshamNameInTamil === 'க்ருஷ்ண' ? 'கி.' : 'சு.';
    const th1 = rec.ThithiNameInTamil || ''; const th2 = rec.Thithi2NameInTamil || '';
    const thEndHr = Math.floor(rec.ThithiDuration || 0); const thEndMin = Math.round(((rec.ThithiDuration || 0) - thEndHr) * 100);
    const thEndStr = thEndHr + '.' + String(thEndMin).padStart(2, '0');
    const thithiDisplay = pakPrefix + abbrThithi(th1) + '(' + thEndStr + ')' + (th2 ? '/' + pakPrefix + abbrThithi(th2) : '');
    return {
      slNo: slNo++, label, type, engDate: fmtDate(rec.EnglishDate), dayName: rec.DayNameInTamil,
      tamilMonth: rec.MonthNameInTamil, tamilDate: rec.TamilDate, thithiInfo: thithiDisplay,
      starInfo: rec.NakshatraNameInTamil + (rec.NakshatraNazhigai ? '-' + rec.NakshatraNazhigai.toFixed(2) : ''),
      notes: type === 'oonam' ? `(நாள் ${days})` : ''
    };
  };

  // Get selected oonam records
  const getOonamRec = (blockIdx) => {
    if (blockIdx >= oonamBlocks.length) return null;
    const sel = oonamBlocks[blockIdx].candidates.find(c => c.selected);
    if (!sel) return null;
    return panchangamData.find(r => fmtDate(r.EnglishDate) === sel.engDate) || null;
  };
  const oonamRecs = [getOonamRec(0), getOonamRec(1), getOonamRec(2), getOonamRec(3)];
  const oonamFallbacks = [27, 45, 175, 348];
  const oonamLabels = ['ஆத்ய ஊனம்', 'த்ரைபக்ஷிகம்', 'ஊன ஷாண்மாஸிகம்', 'ஊன ஆப்தீகம்'];

  // ═══ SHASTRA RULE: Proper interleaving of Oonams and Masyams ═══
  // Adhya Oonam MUST come BEFORE 2nd Masyam (1st masyam block).
  // Traipakshikam must come between 2nd and 3rd Masyam.
  // Oonams are inserted at their correct position relative to masyams.
  
  // Separate oonam events and masyam events
  const oonamEvents = [];
  for (let i = 0; i < 4; i++) {
    oonamEvents.push({
      date: oonamRecs[i] ? new Date(oonamRecs[i].EnglishDate) : new Date(deathDate.getTime() + oonamFallbacks[i] * 86400000),
      type: 'oonam', label: oonamLabels[i], rec: oonamRecs[i], oonamIdx: i
    });
  }
  
  const masyamEvents = [];
  for (const block of masyamBlocks) {
    const sel = block.candidates.find(c => c.selected);
    if (!sel) continue;
    const rec = csvData.find(r => fmtDate(r.EnglishDate) === sel.engDate) || panchangamData.find(r => fmtDate(r.EnglishDate) === sel.engDate);
    if (!rec) continue;
    masyamEvents.push({ date: new Date(rec.EnglishDate), type: block.isAdhika ? 'adhika' : 'masyam', label: block.label, rec });
  }
  masyamEvents.sort((a, b) => a.date.getTime() - b.date.getTime());
  
  // Build timeline: interleave with shastra ordering
  // Rule: Adhya Oonam → 2nd Masyam → Traipakshikam → 3rd Masyam → ... → Oona Shanmasikam → ... → Oona Apthikam
  const allEvents = [];
  
  // 1. Insert Adhya Oonam FIRST (before any masyam)
  allEvents.push(oonamEvents[0]);
  
  // 2. Insert masyams, inserting remaining oonams at correct positions
  const remainingOonams = [oonamEvents[1], oonamEvents[2], oonamEvents[3]]; // traipakshikam, shanmasikam, apthikam
  let oonamInsertIdx = 0;
  
  for (const mev of masyamEvents) {
    // Before adding this masyam, check if any remaining oonam should come before it
    while (oonamInsertIdx < remainingOonams.length && remainingOonams[oonamInsertIdx].date.getTime() <= mev.date.getTime()) {
      allEvents.push(remainingOonams[oonamInsertIdx]);
      oonamInsertIdx++;
    }
    allEvents.push(mev);
  }
  // Add any remaining oonams after all masyams
  while (oonamInsertIdx < remainingOonams.length) {
    allEvents.push(remainingOonams[oonamInsertIdx]);
    oonamInsertIdx++;
  }
  
  for (const ev of allEvents) rows.push(makeRow(ev.label, ev.rec, ev.type));

  // Varshaaptheekam + Sodhakumbam collision detection
  if (varshaBlock && varshaBlock.candidates.length > 0) {
    const vSel = varshaBlock.candidates.find(c => c.selected);
    if (vSel) {
      const vRec = csvData.find(r => fmtDate(r.EnglishDate) === vSel.engDate) || panchangamData.find(r => fmtDate(r.EnglishDate) === vSel.engDate);
      if (vRec) {
        const vDate = new Date(vRec.EnglishDate);

        // ஆப்தீக சோதகும்பம் = day before Varshaaptheekam
        let shodaDate = new Date(vDate); shodaDate.setDate(shodaDate.getDate() - 1);

        // Collision check: if Oona Apthikam (oonam index 3) is on the same day as Sodhakumbam
        const oonaApthikamRec = oonamRecs[3];
        let collisionNote = '';
        if (oonaApthikamRec) {
          const oonaDate = new Date(oonaApthikamRec.EnglishDate);
          const shodaStr = fmtDate(shodaDate);
          const oonaStr = fmtDate(oonaDate);
          if (shodaStr === oonaStr) {
            // Collision! Shift sodhakumbam one day earlier
            shodaDate.setDate(shodaDate.getDate() - 1);
            collisionNote = 'ஊன ஆப்தீகம் அன்றே சோதகும்பம் வருவதால், ஒரு நாள் முன் நகர்த்தப்பட்டது';
          }
        }

        const shodaRec = findRecByDate(panchangamData, shodaDate) || findRecByDate(csvData, shodaDate);
        const shodaRow = makeRow('ஆப்தீக சோதகும்பம்', shodaRec, 'special');
        if (collisionNote) shodaRow.notes = collisionNote;
        rows.push(shodaRow);

        rows.push(makeRow('வருஷாப்தீகம்', vRec, 'special'));

        // ததீயாராதனம் = day after Varshaaptheekam (no conditions)
        const thadDate = new Date(vDate); thadDate.setDate(thadDate.getDate() + 1);
        const thadRec = findRecByDate(panchangamData, thadDate) || findRecByDate(csvData, thadDate);
        rows.push(makeRow('ததீயாராதனம்', thadRec, 'thadhi'));
      }
    }
  }
  return rows;
}

// ═══════════════════════════════════════════════════════════
// BUILD PDF HTML
// ═══════════════════════════════════════════════════════════
function buildPdfHtml(schedule, demisedName, gothram, deathRecordDate, deathTimeIST, personPaksham, personThithiName, deathTamilMonth, deathTamilYear, karthaName, karthaStarName, karthaPhone, karthaAddress, specialNotes) {
  const rc=(t)=>t==='oonam'?'#fff3e0':t==='thadhi'?'#e8f5e9':t==='special'?'#fce4ec':t==='adhika'?'#e8eaf6':'#fff';
  const lc=(t)=>t==='oonam'?'#e65100':t==='thadhi'?'#2e7d32':t==='special'?'#6d1b1b':'#1b5e20';
  const ic=(t)=>t==='oonam'?'◆':t==='thadhi'?'★':t==='special'?'▣':t==='masyam'?'●':'◈';
  const ap=(p)=>p==='க்ருஷ்ண'?'கிரு.':(p==='சுக்ல'?'சு.':p);
  const ay=(y)=>y?y.replace('நாம ஸம்வத்ஸரே','').trim():'';
  const n=schedule.length;
  const fs2=n>18?'7pt':'7.5pt';
  const tp=n>18?'2px 4px':'3px 5px';
  let rows='';
  for(const r of schedule){
    rows+='<tr style="background:'+rc(r.type)+'"><td style="border:1px solid #bbb;text-align:center;font-weight:700;padding:'+tp+'">'+r.slNo+'</td><td style="border:1px solid #bbb;font-weight:700;color:'+lc(r.type)+';white-space:nowrap;padding:'+tp+'">'+ic(r.type)+' '+r.label+'</td><td style="border:1px solid #bbb;font-weight:600;white-space:nowrap;padding:'+tp+'">'+r.engDate+' '+r.dayName+'</td><td style="border:1px solid #bbb;padding:'+tp+'">'+r.thithiInfo+'</td><td style="border:1px solid #bbb;padding:'+tp+'">'+r.starInfo+'</td><td style="border:1px solid #bbb;color:#c62828;font-weight:600;padding:'+tp+'">'+(r.notes||'')+'</td></tr>';
  }
  var css='@page{size:A4;margin:10mm}*{box-sizing:border-box}';
  css+='body{font-family:Latha,Nirmala UI,Segoe UI,Arial,sans-serif;color:#222;margin:0;padding:0;line-height:1.5}';
  css+='.hdr{background:linear-gradient(135deg,#090b72,#1a237e);padding:8px 12px;text-align:center;border-bottom:3px solid #d4af37}';
  css+='.hdr h1{color:#d4af37;font-size:12pt;margin:0;font-weight:900;line-height:1.3}';
  css+='.hdr .s{color:#c8e6c9;font-size:7pt;line-height:1.3}';
  css+='.hdr .t{color:#fff;font-size:9pt;font-weight:800;margin-top:2px;line-height:1.3}';
  css+='.inf{display:flex;gap:8px;padding:6px 0;margin-top:4px}';
  css+='.inf .c{flex:1;border:1.5px solid #1a237e;border-radius:4px;padding:4px 8px;background:#f8f9fa}';
  css+='.inf .c h3{color:#1a237e;font-size:8pt;margin:0 0 2px;padding-bottom:2px;border-bottom:1px solid #c8e6c9;font-weight:800;line-height:1.4}';
  css+='.inf .c p{font-size:7.5pt;margin:1px 0;line-height:1.5}';
  css+='.inf .c .th{color:#1a237e;font-weight:700;font-size:8pt}';
  css+='table{width:100%;border-collapse:collapse;margin:4px 0}';
  css+='th{background:#b40000;color:#fff;padding:3px 5px;font-size:7.5pt;border:1px solid #900;white-space:nowrap;font-weight:700;line-height:1.4}';
  css+='td{font-size:'+fs2+';line-height:1.5;vertical-align:middle}';
  css+='tr{page-break-inside:avoid}';
  css+='.nt{margin:3px 0;background:#fff8e1;border-left:3px solid #f9a825;padding:3px 8px;font-size:6.5pt;color:#5d4037;line-height:1.4}';
  css+='.wr{margin:2px 0;background:#fce4ec;border:1px solid #ef9a9a;padding:3px 8px;font-size:6.5pt;color:#4e342e;line-height:1.4}';
  css+='.ft{text-align:center;padding:4px 0;font-size:7pt;color:#999;border-top:2px solid #d4af37;margin-top:4px}';
  css+='.ft .b{color:#1a237e;font-weight:700;font-size:7.5pt}';
  var html='<!DOCTYPE html><html><head><meta charset="utf-8"/><style>'+css+'</style></head><body>';
  html+='<div class="hdr"><h1>❀ ஸ்ரீ பரந்தாமன் பஞ்சாங்கம் ❀</h1>';
  html+='<div class="s">Sri Paranthaman Panchangam — Panchanga Service</div>';
  html+='<div class="t">வருடாந்திர ஊனம் &amp; மாஸ்யம் பட்டியல்</div></div>';
  html+='<div class="inf"><div class="c"><h3>✿ இறந்தவர் விபரம்</h3>';
  html+='<p><b>பெயர்:</b> '+(demisedName||'—')+' &nbsp; <b>கோத்ரம்:</b> '+(gothram||'—')+'</p>';
  html+='<p><b>தேதி:</b> '+fmtDate(deathRecordDate)+' — '+deathTimeIST+'</p>';
  html+='<p class="th"><b>ச்ராத்-திதி:</b> '+ay(deathTamilYear)+'-'+(deathTamilMonth||'')+'-'+ap(personPaksham)+' '+personThithiName+'</p>';
  html+='</div><div class="c"><h3>★ கர்த்தா விபரம்</h3>';
  html+='<p><b>பெயர்:</b> '+(karthaName||'—')+' &nbsp; <b>நக்ஷத்ரம்:</b> '+(karthaStarName||'—')+'</p>';
  if(karthaPhone) html+='<p><b>Ph:</b> '+karthaPhone+'</p>';
  html+='</div></div>';
  html+='<table><thead><tr><th style="width:18px;text-align:center">#</th><th>விபரம்</th><th>தேதி / கிழமை</th><th>திதி</th><th>நக்ஷத்ரம்</th><th>குறிப்பு</th></tr></thead><tbody>'+rows+'</tbody></table>';
  html+='<div class="nt">✎ '+STANDARD_NOTE+'</div>';
  if(specialNotes) html+='<div class="nt" style="border-left-color:#6d1b1b">✎ '+specialNotes+'</div>';
  html+='<div class="wr"><b>⚠️ முக்கிய அறிவிப்பு:</b> தேதிகள் சாஸ்திர விதிகளின்படி தானியங்கி கணக்கீடு. தர்ம சூக்ஷ்மம் காரணமாக விதிவிலக்கு சாத்தியம் — குருவிடம் சரிபார்க்கவும். <b>இறுதி முடிவு தங்களுடையது.</b></div>';
  html+='<div class="ft"><div class="b">❀ ஸ்ரீ பரந்தாமன் பஞ்சாங்கம் — Sri Paranthaman Panchangam ❀</div>';
  html+='<div>www.ahobilam.com | Play Store: Paranthaman Panchangam</div></div>';
  html+='</body></html>';
  return html;
}

// ═══════════════════════════════════════════════════════════
// SHARE TEXT
// ═══════════════════════════════════════════════════════════
function getShareText(schedule, demisedName, gothram, deathRecordDate, deathTimeIST, personPaksham, personThithiName, deathTamilMonth, deathTamilYear, karthaName, karthaStarName, specialNotes) {
  let text = '❀ *ஸ்ரீ பரந்தாமன் பஞ்சாங்கம்*\n— Panchanga Service —\n\n═══════════════════════\n*வருடாந்திர ஊனம் & மாஸ்யம் பட்டியல்*\n═══════════════════════\n\n';
  if (demisedName) text += '✿ இறந்தவர்: *' + demisedName + '*\n';
  if (gothram) text += '✿ கோத்ரம்: ' + gothram + '\n';
  text += '✦ இறந்த தேதி: ' + fmtDate(deathRecordDate) + ' — ' + deathTimeIST + '\n';
  text += '✦ ச்ராத்த திதி: ' + personPaksham + ' ' + personThithiName + '\n';
  text += '✦ ' + deathTamilMonth + ' (' + deathTamilYear + ')\n\n';
  text += '★ கர்த்தா: ' + (karthaName || '—') + '\n';
  text += '★ நக்ஷத்திரம்: ' + karthaStarName + '\n';
  text += '───────────────────────\n\n';
  for (const row of schedule) {
    const icon = row.type === 'oonam' ? '◆' : row.type === 'masyam' ? '●' : row.type === 'thadhi' ? '★' : row.type === 'special' ? '▣' : '◈';
    text += icon + ' ' + row.slNo + '. ' + row.label + '\n';
    text += '   ✦ ' + row.engDate + ' — ' + row.dayName + ' (' + row.starInfo + ')\n';
    text += '   ✦ ' + row.thithiInfo + '\n';
    if (row.notes) text += '   ✎ ' + row.notes + '\n';
    text += '\n';
  }
  text += '───────────────────────\n✎ ' + STANDARD_NOTE + '\n';
  if (specialNotes) text += '✎ குறிப்பு: ' + specialNotes + '\n';
  text += '\n❀ ஸ்ரீ பரந்தாமன் பஞ்சாங்கம்';
  return text.trim();
}

// ═══════════════════════════════════════════════════════════
// MAIN COMPONENT
// ═══════════════════════════════════════════════════════════
const FullOonamListPage = () => {
  // ═══ FEEDBACK COMMENTS (simple, no login needed) ═══
  const [comments, setComments] = useState(() => {
    try { return JSON.parse(localStorage.getItem('oonam_comments') || '[]'); } catch { return []; }
  });
  const [newComment, setNewComment] = useState('');
  const [commentName, setCommentName] = useState(localStorage.getItem('oonam_user_name') || '');
  const [replyingTo, setReplyingTo] = useState(null);
  const [replyText, setReplyText] = useState('');

  const saveComments = (c) => { setComments(c); localStorage.setItem('oonam_comments', JSON.stringify(c)); };
  const postComment = () => {
    if (!newComment.trim() || !commentName.trim()) { alert('பெயர் மற்றும் கருத்து இரண்டும் கட்டாயம்'); return; }
    localStorage.setItem('oonam_user_name', commentName);
    const c = { id: Date.now().toString(), user_name: commentName, message: newComment, created_at: new Date().toISOString(), replies: [] };
    saveComments([c, ...comments]);
    setNewComment('');
  };
  const postReply = (commentId) => {
    if (!replyText.trim() || !commentName.trim()) return;
    localStorage.setItem('oonam_user_name', commentName);
    const updated = comments.map(c => c.id === commentId ? { ...c, replies: [...(c.replies||[]), { id: Date.now().toString(), user_name: commentName, message: replyText, created_at: new Date().toISOString() }] } : c);
    saveComments(updated);
    setReplyText(''); setReplyingTo(null);
  };

  // Form
  const [step, setStep] = useState('form');
  const [deathDate, setDeathDate] = useState(new Date().toISOString().split('T')[0]);
  const [deathTimeHour, setDeathTimeHour] = useState(12);
  const [deathTimeMinute, setDeathTimeMinute] = useState(0);
  const [deathTimePeriod, setDeathTimePeriod] = useState('PM');
  const [demisedName, setDemisedName] = useState('');
  const [gothram, setGothram] = useState('');
  const [gothramSuggestions, setGothramSuggestions] = useState([]);
  const [showGothramDropdown, setShowGothramDropdown] = useState(false);
  const [karthaName, setKarthaName] = useState('');
  const [karthaAddress, setKarthaAddress] = useState('');
  const [karthaPhone, setKarthaPhone] = useState('');
  const [karthaStarNumber, setKarthaStarNumber] = useState(0);
  const [specialNotes, setSpecialNotes] = useState('');

  // Data
  const [panchangamData, setPanchangamData] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const [loading, setLoading] = useState(false);

  // Death info
  const [deathRecord, setDeathRecord] = useState(null);
  const [determinedThithi1, setDeterminedThithi1] = useState('');
  const [determinedThithi2, setDeterminedThithi2] = useState('');
  const [thithi1EndTime, setThithi1EndTime] = useState('');
  const [deathTimeIST, setDeathTimeIST] = useState('');
  const [selectedThithi, setSelectedThithi] = useState('thithi1');

  // Confirmed shradha thithi
  const [personThithiName, setPersonThithiName] = useState('');
  const [personPaksham, setPersonPaksham] = useState('');
  const [deathTamilMonth, setDeathTamilMonth] = useState('');
  const [deathTamilYear, setDeathTamilYear] = useState('');

  // Schedule
  const [schedule, setSchedule] = useState([]);
  const [isExporting, setIsExporting] = useState(false);
  const [oonamBlocks, setOonamBlocks] = useState([]);
  const [masyamBlocks, setMasyamBlocks] = useState([]);
  const [varshaBlock, setVarshaBlock] = useState(null);
  const [oonamFilters, setOonamFilters] = useState(DEFAULT_OONAM_FILTERS);

  // Load data on mount
  useEffect(() => {
    setLoading(true);
    Promise.all([
      axios.get('/data/panchangam_data-2025-to-2028.json').then(r => r.data).catch(() => []),
      loadCSVFiles()
    ]).then(([pData, cData]) => {
      setPanchangamData(pData);
      setCsvData(cData);
      setLoading(false);
    });
  }, []);

  // ═══════ STEP 1 → STEP 2 ═══════
  const determineThithi = () => {
    if (!deathDate || !karthaStarNumber) { alert('இறந்த தேதி, நேரம் மற்றும் கர்த்தா நக்ஷத்திரம் கட்டாயம்.'); return; }
    const deathTime24 = convertTo24HrDecimal(deathTimeHour, deathTimeMinute, deathTimePeriod);
    setDeathTimeIST(`${deathTimeHour}:${String(deathTimeMinute).padStart(2, '0')} ${deathTimePeriod}`);
    const deathDateStr = deathDate;
    let rec = panchangamData.find(r => formatToYMD(r.EnglishDate) === deathDateStr) || null;
    if (!rec) { alert('2025-2029 வரையிலான தேதிகளை மட்டும் தேர்வு செய்யவும்.'); return; }

    // Midnight rule
    if (deathTime24 < 2) {
      const prevDate = new Date(rec.EnglishDate); prevDate.setDate(prevDate.getDate() - 1);
      const prevRec = findRecByDate(panchangamData, prevDate);
      if (prevRec) rec = prevRec;
    }

    const thithiEndDecimal = rec.ThithiDuration;
    const thithiEndHr = Math.floor(thithiEndDecimal);
    const thithiEndMin = Math.round((thithiEndDecimal - thithiEndHr) * 100);
    setDeterminedThithi1(`${rec.PakshamNameInTamil} ${rec.ThithiNameInTamil}`);
    setDeterminedThithi2(rec.Thithi2NameInTamil ? `${rec.PakshamNameInTamil} ${rec.Thithi2NameInTamil}` : '');
    if (thithiEndHr >= 24) {
      const adj = thithiEndHr - 24;
      setThithi1EndTime(`${adj === 0 ? 12 : adj}:${String(thithiEndMin).padStart(2, '0')} AM (மறுநாள்)`);
    } else {
      const h12 = thithiEndHr > 12 ? thithiEndHr - 12 : (thithiEndHr === 0 ? 12 : thithiEndHr);
      const period = thithiEndHr >= 12 ? 'PM' : 'AM';
      setThithi1EndTime(`${h12}:${String(thithiEndMin).padStart(2, '0')} ${period}`);
    }
    setSelectedThithi(deathTime24 <= thithiEndDecimal ? 'thithi1' : 'thithi2');
    setDeathTamilMonth(TAMIL_MONTH_MAP[rec.MonthNameInTamil] || rec.MonthNameInTamil);
    setDeathTamilYear(rec.YearNameInTamil);
    setDeathRecord(rec);
    setStep('confirm');
  };

  // ═══════ STEP 2 → STEP 3 ═══════
  const confirmAndGenerate = () => {
    let pThithiName, pPaksham;
    if (selectedThithi === 'thithi1') {
      pThithiName = deathRecord.ThithiNameInTamil;
      pPaksham = deathRecord.PakshamNameInTamil;
    } else {
      pThithiName = deathRecord.Thithi2NameInTamil;
      const th1Num = deathRecord.ThithiNumber;
      if (th1Num === 30 || th1Num === 15) pPaksham = deathRecord.PakshamNameInTamil === 'க்ருஷ்ண' ? 'சுக்ல' : 'க்ருஷ்ண';
      else pPaksham = deathRecord.PakshamNameInTamil;
    }
    setPersonThithiName(pThithiName);
    setPersonPaksham(pPaksham);
    const deathDateObj = new Date(deathRecord.EnglishDate);
    const oBlocks = [
      buildOonamBlock('ஆத்ய ஊனம்', '(நாள் 27-30)', deathDateObj, 27, 30, panchangamData, karthaStarNumber, 28, 29),
      buildOonamBlock('த்ரைபக்ஷிகம்', '(நாள் 41-45)', deathDateObj, 41, 45, panchangamData, karthaStarNumber),
      buildOonamBlock('ஊன ஷாண்மாஸிகம்', '(நாள் 171-179)', deathDateObj, 171, 179, panchangamData, karthaStarNumber),
      buildOonamBlock('ஊன ஆப்தீகம்', '(நாள் 341-355)', deathDateObj, 341, 355, panchangamData, karthaStarNumber)
    ];
    // Apply Shastra filter-based auto-selection
    const filteredOBlocks = oBlocks.map(block => {
      const cands = block.candidates.map(c => ({ ...c, selected: false }));
      const isGood = c => !c.checks.some(chk => oonamFilters[chk.id] && !chk.pass);
      const firstStandardGood = cands.find(c => !c.isExemption && isGood(c));
      const firstExemptionGood = cands.find(c => c.isExemption && isGood(c));
      if (firstStandardGood) firstStandardGood.selected = true;
      else if (firstExemptionGood) firstExemptionGood.selected = true;
      else if (cands.length > 0) cands[0].selected = true;
      return { ...block, candidates: cands };
    });
    setOonamBlocks(filteredOBlocks);
    const mBlocks = buildMasyamBlocks(deathDateObj, pThithiName, pPaksham, panchangamData, csvData);
    setMasyamBlocks(mBlocks);
    
    // ═══ SHASTRA RULE: Adhya Oonam MUST be before 2nd Masyam ═══
    // If 1st masyam date <= Adhya Oonam selected date, force Adhya Oonam to day before masyam
    if (mBlocks.length > 0 && filteredOBlocks[0].candidates.length > 0) {
      const firstMasyamSel = mBlocks[0].candidates.find(c => c.selected);
      if (firstMasyamSel) {
        const masyamDate = new Date(firstMasyamSel.rawDate);
        const adhyaSel = filteredOBlocks[0].candidates.find(c => c.selected);
        if (adhyaSel) {
          const adhyaDate = new Date(adhyaSel.rawDate);
          if (adhyaDate.getTime() >= masyamDate.getTime()) {
            const forcedDate = new Date(masyamDate);
            forcedDate.setDate(forcedDate.getDate() - 1);
            const forcedDateStr = fmtDate(forcedDate);
            let found = false;
            filteredOBlocks[0].candidates.forEach(c => {
              c.selected = false;
              if (c.engDate === forcedDateStr) { c.selected = true; found = true; }
            });
            if (!found) {
              filteredOBlocks[0].candidates[0].selected = true;
            }
            setOonamBlocks([...filteredOBlocks]);
          }
        }
      }
    }
    
    const vBlock = buildVarshaBlock(deathRecord, pThithiName, pPaksham, panchangamData, csvData);
    setVarshaBlock(vBlock);
    setStep('masyam-select');
  };

  // ═══════ STEP 3 → STEP 4 ═══════
  const confirmMasyamsAndGenerate = () => {
    const deathDateObj = new Date(deathRecord.EnglishDate);
    const sched = buildSchedule(deathDateObj, oonamBlocks, masyamBlocks, varshaBlock, panchangamData, csvData);
    setSchedule(sched);
    setStep('review');
  };

  // Candidate selections
  const selectOonamCandidate = (blockIdx, candIdx) => {
    const newBlocks = [...oonamBlocks];
    newBlocks[blockIdx].candidates.forEach(c => c.selected = false);
    newBlocks[blockIdx].candidates[candIdx].selected = true;
    setOonamBlocks(newBlocks);
  };
  const selectMasyamCandidate = (blockIdx, candIdx) => {
    const newBlocks = [...masyamBlocks];
    newBlocks[blockIdx].candidates.forEach(c => c.selected = false);
    newBlocks[blockIdx].candidates[candIdx].selected = true;
    setMasyamBlocks(newBlocks);
  };
  const selectVarshaCandidate = (candIdx) => {
    if (!varshaBlock) return;
    const newBlock = { ...varshaBlock, candidates: varshaBlock.candidates.map((c, i) => ({ ...c, selected: i === candIdx })) };
    setVarshaBlock(newBlock);
  };

  // Apply auto-selection to oonam blocks based on current filters
  const applyOonamAutoSelect = (blocks, filters) => {
    return blocks.map(block => {
      const cands = block.candidates.map(c => ({ ...c, selected: false }));
      const isGood = c => !c.checks.some(chk => filters[chk.id] && !chk.pass);
      // Prefer non-exemption good days first, then exemption good days, then any day
      const firstStandardGood = cands.find(c => !c.isExemption && isGood(c));
      const firstExemptionGood = cands.find(c => c.isExemption && isGood(c));
      if (firstStandardGood) firstStandardGood.selected = true;
      else if (firstExemptionGood) firstExemptionGood.selected = true;
      else if (cands.length > 0) cands[0].selected = true;
      return { ...block, candidates: cands };
    });
  };
  const toggleOonamFilter = (filterId) => {
    const newFilters = { ...oonamFilters, [filterId]: !oonamFilters[filterId] };
    setOonamFilters(newFilters);
    setOonamBlocks(applyOonamAutoSelect(oonamBlocks, newFilters));
  };

  const resetForm = () => {
    setStep('form'); setSchedule([]); setOonamBlocks([]); setMasyamBlocks([]); setVarshaBlock(null);
    setDeathDate(new Date().toISOString().split('T')[0]);
    setDeathTimeHour(12); setDeathTimeMinute(0); setDeathTimePeriod('PM');
    setDemisedName(''); setGothram(''); setKarthaName(''); setKarthaAddress('');
    setKarthaPhone(''); setKarthaStarNumber(0); setSpecialNotes(''); setDeathRecord(null);
  };

  const karthaStarName = STARS.find(s => s.value === karthaStarNumber)?.name || '';

  const shareWhatsApp = () => {
    const text = getShareText(schedule, demisedName, gothram, deathRecord?.EnglishDate, deathTimeIST, personPaksham, personThithiName, deathTamilMonth, deathTamilYear, karthaName, karthaStarName, specialNotes);
    window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, '_blank');
  };
  const copyToClipboard = async () => {
    const text = getShareText(schedule, demisedName, gothram, deathRecord?.EnglishDate, deathTimeIST, personPaksham, personThithiName, deathTamilMonth, deathTamilYear, karthaName, karthaStarName, specialNotes);
    try { await navigator.clipboard.writeText(text); alert('📋 நகலெடுக்கப்பட்டது!'); } catch { alert('நகலில் பிழை'); }
  };

  // ═══════ STYLES ═══════
  const inputStyle = { width:'100%', padding:'10px', borderRadius:'8px', border:'1px solid #ccc', fontSize:'0.9rem', boxSizing:'border-box' };
  const labelStyle = { display:'block', fontSize:'0.85rem', fontWeight:800, color:T.greenDk, marginBottom:'4px' };
  const cardStyle = { background:'#fff', borderRadius:'10px', padding:'16px', marginBottom:'12px', boxShadow:'0 2px 6px rgba(0,0,0,0.08)' };
  const btnPrimary = { padding:'12px 24px', background:T.greenDk, color:'#fff', border:'none', borderRadius:'8px', fontWeight:'bold', fontSize:'1rem', cursor:'pointer', width:'100%' };
  const sectionHeadStyle = { background:T.header, color:'#d4af37', padding:'10px 14px', borderRadius:'8px', margin:'0 0 14px', fontSize:'1rem', fontWeight:900, textAlign:'center' };

  // ═══════ AUTH CHECK ═══════
  const navigate = useNavigate();
  const storedToken = localStorage.getItem('token');
  const storedUser = localStorage.getItem('user');
  const isLoggedIn = !!storedToken;
  let userName = '';
  try { if (storedUser) userName = JSON.parse(storedUser).name || ''; } catch(e) {}
  if (!isLoggedIn) {
    return (
      <div style={{background:T.bg,minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',padding:'20px'}}>
        <div style={{maxWidth:'480px',width:'100%',background:'#fff',borderRadius:'16px',padding:'28px',boxShadow:'0 8px 32px rgba(0,0,0,0.12)',textAlign:'center'}}>
          <div style={{background:T.header,padding:'18px',borderRadius:'12px',marginBottom:'20px'}}>
            <h1 style={{color:'#d4af37',margin:0,fontSize:'1.2rem',fontWeight:900}}>📋 முழு ஊன-மாஸிக பட்டியல்</h1>
            <div style={{color:'#c8e6c9',fontSize:'0.8rem',marginTop:'4px'}}>Full Oonam & Masikam Schedule Generator</div>
          </div>
          <div style={{background:'#fff3e0',border:'1px solid #ffe082',borderRadius:'8px',padding:'14px',marginBottom:'20px',fontSize:'0.85rem',color:'#e65100'}}>
            🔒 இந்தப் பக்கத்தைப் பயன்படுத்த முதலில் உள்நுழையவும்
          </div>
          <p style={{color:'#555',fontSize:'0.9rem',marginBottom:'20px',lineHeight:1.6}}>ஊனம் மற்றும் மாஸிகம் பட்டியல் தயாரிக்க, தயவு செய்து உள்நுழையவும் அல்லது புதிய கணக்கு உருவாக்கவும்.</p>
          <p style={{color:'#888',fontSize:'0.8rem',marginBottom:'20px'}}>Please sign in to use this feature. If you don't have an account, click the Login/Register button in the top menu.</p>
          <button onClick={()=>{window.dispatchEvent(new Event('openAuthModal'));}} style={{width:'100%',padding:'14px',background:T.greenDk,color:'#fff',border:'none',borderRadius:'10px',fontWeight:900,fontSize:'1rem',cursor:'pointer',marginBottom:'10px'}}>🔑 உள்நுழை / Login</button>
        </div>
      </div>
    );
  }

  if (loading) return <div style={{background:T.bg,minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center'}}><p style={{color:T.greenDk,fontWeight:'bold'}}>📂 பஞ்சாங்க தரவுகள் ஏற்றப்படுகின்றன...</p></div>;

  return (
    <div className="oonam-page" style={{background:T.bg,minHeight:'100vh',padding:'12px',paddingBottom:'80px',maxWidth:'800px',margin:'0 auto'}}>
      <style>{`
        .oonam-page h1,
        .oonam-page h2,
        .oonam-page h3 {
          background: none !important;
          background-color: transparent !important;
          border: none !important;
          border-radius: 0 !important;
        }
        .oonam-page .oonam-header-title {
          color: #d4af37 !important;
          font-size: 1.15rem !important;
          text-align: center !important;
        }
        .oonam-page .oonam-section-head {
          color: #d4af37 !important;
          background: linear-gradient(135deg, #090b72, #1a237e) !important;
          padding: 10px 14px !important;
          border-radius: 8px !important;
          font-size: 1rem !important;
          text-align: center !important;
          margin: 0 0 14px !important;
          font-weight: 900 !important;
        }
        .oonam-page .oonam-sub-head {
          color: #7b1fa2 !important;
          font-size: 0.95rem !important;
          margin: 0 0 6px !important;
        }
        .oonam-page .oonam-sub-orange {
          color: #e65100 !important;
          font-size: 1rem !important;
          margin: 0 0 4px !important;
        }
        .oonam-page .oonam-sub-green {
          color: #1b5e20 !important;
          font-size: 1rem !important;
          margin: 0 0 4px !important;
        }
        .oonam-page .oonam-sub-maroon {
          color: #6d1b1b !important;
          font-size: 0.85rem !important;
        }
        .oonam-page th {
          color: #d4af37 !important;
          background: linear-gradient(135deg, #090b72, #1a237e) !important;
        }
      `}</style>
      {/* Header */}
      <div style={{background:T.header,padding:'14px',borderRadius:'12px',textAlign:'center',marginBottom:'14px',boxShadow:'0 4px 8px rgba(0,0,0,0.15)'}}>
        <h1 className="oonam-header-title" style={{margin:0,fontWeight:900}}>📋 முழு ஊன-மாஸிக பட்டியல்</h1>
        <div style={{color:'#e8f5e9',fontSize:'0.75rem',marginTop:'3px'}}>Full Oonam & Masikam Schedule Generator</div>
        {userName && <div style={{color:'#c8e6c9',fontSize:'0.7rem',marginTop:'4px'}}>👤 {userName}</div>}
      </div>

      {/* ═══════ STEP 1: FORM ═══════ */}
      {step === 'form' && (
        <div style={cardStyle}>
          <h2 className="oonam-section-head">✿ இறந்தவர் விபரம்</h2>
          <div style={{marginBottom:'10px'}}><label style={labelStyle}>இறந்தவர் பெயர்</label><input value={demisedName} onChange={e=>setDemisedName(e.target.value)} style={inputStyle} placeholder="பெயர்" /></div>
          <div style={{marginBottom:'10px',position:'relative'}}>
            <label style={labelStyle}>கோத்ரம்</label>
            <input value={gothram} onChange={e=>{
              const val = e.target.value;
              setGothram(val);
              if (val.length >= 2) {
                const norm = val.toLowerCase();
                const matches = abhivadhi.filter(g => g.Gothram && g.Gothram.toLowerCase().includes(norm)).slice(0, 8);
                setGothramSuggestions(matches);
                setShowGothramDropdown(matches.length > 0);
              } else { setShowGothramDropdown(false); }
            }} onFocus={()=>{ if (gothramSuggestions.length > 0) setShowGothramDropdown(true); }}
            style={inputStyle} placeholder="கோத்ரம் தட்டச்சு செய்க (எ.கா. Bhar)" autoComplete="off" />
            {showGothramDropdown && (
              <div style={{position:'absolute',top:'100%',left:0,right:0,zIndex:10,background:'#fff',border:'1px solid #ccc',borderRadius:'0 0 8px 8px',maxHeight:'200px',overflowY:'auto',boxShadow:'0 4px 8px rgba(0,0,0,0.15)'}}>
                {gothramSuggestions.map((g, i) => (
                  <div key={i} onClick={()=>{ setGothram(g.Gothram); setShowGothramDropdown(false); }}
                    style={{padding:'8px 10px',cursor:'pointer',borderBottom:'1px solid #f0f0f0',fontSize:'0.8rem'}}
                    onMouseEnter={e=>e.currentTarget.style.background='#e8f5e9'}
                    onMouseLeave={e=>e.currentTarget.style.background='#fff'}>
                    <div style={{fontWeight:700,color:T.maroon}}>{g.Gothram}</div>
                    <div style={{fontSize:'0.65rem',color:'#888'}}>{g.Pravaram}</div>
                  </div>
                ))}
              </div>
            )}
          </div>
          <div style={{display:'flex',gap:'10px',marginBottom:'10px'}}>
            <div style={{flex:1}}><label style={labelStyle}>இறந்த தேதி</label><input type="date" value={deathDate} onChange={e=>setDeathDate(e.target.value)} style={inputStyle} /></div>
          </div>
          <div style={{display:'flex',gap:'8px',marginBottom:'12px'}}>
            <div style={{flex:1}}><label style={labelStyle}>மணி</label><select value={deathTimeHour} onChange={e=>setDeathTimeHour(parseInt(e.target.value))} style={inputStyle}>{[1,2,3,4,5,6,7,8,9,10,11,12].map(h=><option key={h} value={h}>{h}</option>)}</select></div>
            <div style={{flex:1}}><label style={labelStyle}>நிமிடம்</label><select value={deathTimeMinute} onChange={e=>setDeathTimeMinute(parseInt(e.target.value))} style={inputStyle}>{Array.from({length:60},(_,i)=>i).map(m=><option key={m} value={m}>{String(m).padStart(2,'0')}</option>)}</select></div>
            <div style={{flex:1}}><label style={labelStyle}>AM/PM</label><select value={deathTimePeriod} onChange={e=>setDeathTimePeriod(e.target.value)} style={inputStyle}><option value="AM">AM</option><option value="PM">PM</option></select></div>
          </div>

          <h2 className="oonam-section-head">★ கர்த்தா விபரம்</h2>
          <div style={{marginBottom:'10px'}}><label style={labelStyle}>கர்த்தா பெயர்</label><input value={karthaName} onChange={e=>setKarthaName(e.target.value)} style={inputStyle} placeholder="பெயர்" /></div>
          <div style={{marginBottom:'10px'}}><label style={labelStyle}>கர்த்தா நக்ஷத்திரம் *</label>
            <select value={karthaStarNumber} onChange={e=>setKarthaStarNumber(parseInt(e.target.value))} style={{...inputStyle,fontWeight:700}}>
              <option value={0}>-- தேர்வு செய்க --</option>
              {STARS.map(s=><option key={s.value} value={s.value}>{s.value}. {s.name}</option>)}
            </select>
          </div>
          <div style={{display:'flex',gap:'10px',marginBottom:'10px'}}>
            <div style={{flex:1}}><label style={labelStyle}>தொலைபேசி</label><input value={karthaPhone} onChange={e=>setKarthaPhone(e.target.value)} style={inputStyle} /></div>
          </div>
          <div style={{marginBottom:'10px'}}><label style={labelStyle}>முகவரி</label><input value={karthaAddress} onChange={e=>setKarthaAddress(e.target.value)} style={inputStyle} /></div>
          <div style={{marginBottom:'14px'}}><label style={labelStyle}>குறிப்பு</label><textarea value={specialNotes} onChange={e=>setSpecialNotes(e.target.value)} style={{...inputStyle,height:'60px'}} /></div>

          <button onClick={determineThithi} style={btnPrimary}>📅 திதி கணக்கிடு</button>
        </div>
      )}

      {/* ═══════ STEP 2: CONFIRM THITHI ═══════ */}
      {step === 'confirm' && deathRecord && (
        <div style={cardStyle}>
          <h2 className="oonam-section-head">📌 திதி உறுதிப்படுத்தல்</h2>
          <div style={{background:'#e8f5e9',padding:'12px',borderRadius:'8px',marginBottom:'12px'}}>
            <div style={{fontSize:'0.85rem',color:T.greenDk,fontWeight:700}}>📆 {fmtDate(deathRecord.EnglishDate)} — {deathRecord.DayNameInTamil}</div>
            <div style={{fontSize:'0.8rem',color:'#555',marginTop:'4px'}}>🕐 இறந்த நேரம்: {deathTimeIST}</div>
            <div style={{fontSize:'0.8rem',color:'#555'}}>🗓️ {deathTamilYear} - {deathTamilMonth} - {deathRecord.TamilDate}</div>
          </div>

          <div style={{marginBottom:'12px'}}>
            <div style={{fontSize:'0.85rem',fontWeight:700,color:T.greenDk,marginBottom:'6px'}}>இறக்கும்போது நடந்த திதி:</div>
            <label style={{display:'flex',alignItems:'center',padding:'10px',background:selectedThithi==='thithi1'?'#e3f2fd':'#f5f5f5',borderRadius:'8px',marginBottom:'6px',cursor:'pointer',border:selectedThithi==='thithi1'?'2px solid #1976d2':'1px solid #ddd'}}>
              <input type="radio" name="thithi" checked={selectedThithi==='thithi1'} onChange={()=>setSelectedThithi('thithi1')} style={{marginRight:'8px'}} />
              <div>
                <div style={{fontWeight:700,fontSize:'0.9rem'}}>{determinedThithi1}</div>
                <div style={{fontSize:'0.75rem',color:'#888'}}>({thithi1EndTime} வரை)</div>
              </div>
            </label>
            {determinedThithi2 && (
              <label style={{display:'flex',alignItems:'center',padding:'10px',background:selectedThithi==='thithi2'?'#e3f2fd':'#f5f5f5',borderRadius:'8px',cursor:'pointer',border:selectedThithi==='thithi2'?'2px solid #1976d2':'1px solid #ddd'}}>
                <input type="radio" name="thithi" checked={selectedThithi==='thithi2'} onChange={()=>setSelectedThithi('thithi2')} style={{marginRight:'8px'}} />
                <div style={{fontWeight:700,fontSize:'0.9rem'}}>{determinedThithi2}</div>
              </label>
            )}
          </div>

          <div style={{display:'flex',gap:'8px'}}>
            <button onClick={()=>setStep('form')} style={{...btnPrimary,background:'#999',flex:1}}>◀ திருத்த</button>
            <button onClick={confirmAndGenerate} style={{...btnPrimary,flex:2}}>✅ உறுதிசெய் & தேதிகள் கணக்கிடு</button>
          </div>
        </div>
      )}

      {/* ═══════ STEP 3: MASYAM SELECT ═══════ */}
      {step === 'masyam-select' && (
        <div>
          {/* Shastra Filter Panel */}
          <div style={{...cardStyle,borderLeft:'4px solid #7b1fa2',marginBottom:'10px'}}>
            <h2 className="oonam-sub-head">🔍 சாஸ்திர வடிகட்டி (ஊனம் தேதிக்கு)</h2>
            <p style={{fontSize:'0.65rem',color:'#888',margin:'0 0 8px'}}>ஸ்ம்ருதிமுக்தாபலம் படி — தேவையான விதிகளை ON/OFF செய்யவும்</p>
            <div style={{display:'flex',flexWrap:'wrap',gap:'5px'}}>
              {OONAM_FILTER_DEFS.map(f => (
                <label key={f.id} onClick={() => toggleOonamFilter(f.id)} style={{
                  display:'flex',alignItems:'center',gap:'4px',
                  padding:'4px 8px',borderRadius:'6px',cursor:'pointer',fontSize:'0.72rem',
                  background: oonamFilters[f.id] ? '#f3e5f5' : '#f5f5f5',
                  border: oonamFilters[f.id] ? '1.5px solid #7b1fa2' : '1px solid #ddd',
                  color: oonamFilters[f.id] ? '#4a148c' : '#aaa',
                  fontWeight: oonamFilters[f.id] ? 700 : 400
                }}>
                  <input type="checkbox" checked={oonamFilters[f.id]} onChange={() => {}} style={{accentColor:'#7b1fa2'}} />
                  <span>{f.label}</span>
                  {f.desc && <span style={{fontSize:'0.55rem',color:'#999',marginLeft:'2px'}}>({f.desc})</span>}
                </label>
              ))}
            </div>
          </div>

          <div style={{...cardStyle,borderLeft:'4px solid '+T.orange}}>
            <h2 className="oonam-sub-orange">◆ ஊனம் தேதி தேர்வு</h2>
            <p style={{fontSize:'0.75rem',color:'#666',margin:'0 0 12px'}}>🟢 சரியான நாள் | 🔴 தவிர்க்கவேண்டியது | ✓ தானியங்கி தேர்வு</p>
            {oonamBlocks.map((block, bi) => {
              const goodCount = block.candidates.filter(c => !c.checks.some(chk => oonamFilters[chk.id] && !chk.pass)).length;
              return (
              <div key={bi} style={{marginBottom:'14px',background:'#fff8e1',padding:'10px',borderRadius:'8px',border:'1px solid #ffe082'}}>
                <div style={{fontWeight:800,color:T.maroon,fontSize:'0.9rem',marginBottom:'6px'}}>
                  {block.label} <span style={{fontWeight:400,fontSize:'0.75rem',color:'#888'}}>{block.dayRange}</span>
                  <span style={{fontSize:'0.7rem',marginLeft:'8px',padding:'2px 6px',borderRadius:'4px',
                    background: goodCount > 0 ? '#e8f5e9' : '#ffebee',
                    color: goodCount > 0 ? '#2e7d32' : '#c62828', fontWeight:700
                  }}>{goodCount}/{block.candidates.length} நல்ல நாட்கள்</span>
                </div>
                {block.candidates.length === 0 && <div style={{fontSize:'0.8rem',color:'#999'}}>தேதிகள் இல்லை</div>}
                {block.candidates.map((c, ci) => {
                  const isBadDay = c.checks.some(chk => oonamFilters[chk.id] && !chk.pass);
                  const activeChecks = c.checks.filter(chk => oonamFilters[chk.id]);
                  const failedRules = activeChecks.filter(chk => !chk.pass);
                  return (
                  <div key={ci} onClick={()=>selectOonamCandidate(bi, ci)} style={{
                    padding:'8px',borderRadius:'6px',marginBottom:'5px',cursor:'pointer',
                    background: c.selected ? '#c8e6c9' : (isBadDay ? '#ffebee' : '#fff'),
                    border: c.selected ? '2px solid '+T.success : '1px solid #eee'
                  }}>
                    <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                      <div style={{display:'flex',alignItems:'center',gap:'6px'}}>
                        <input type="radio" name={`oonam-${bi}`} checked={c.selected} onChange={()=>selectOonamCandidate(bi, ci)} />
                        <div>
                          <div style={{fontWeight:700,fontSize:'0.8rem',color:isBadDay?T.danger:T.greenDk}}>
                            {c.isExemption && <span style={{background:'#ff6f00',color:'#fff',padding:'1px 5px',borderRadius:'3px',fontSize:'0.58rem',marginRight:'4px',fontWeight:700}}>விதிவிலக்கு</span>}
                            {c.engDate} — {c.dayName}
                          </div>
                          <div style={{fontSize:'0.7rem',color:'#666'}}>{c.thithiInfo} | {c.starInfo}</div>
                        </div>
                      </div>
                      <div style={{display:'flex',alignItems:'center',gap:'6px'}}>
                        {c.dayCount != null && <span style={{fontSize:'0.62rem',color:'#555',background:'#f0f0f0',padding:'2px 6px',borderRadius:'4px',fontWeight:600,whiteSpace:'nowrap'}}>{c.dayCount}வது நாள்</span>}
                        {c.selected && <span style={{color:T.success,fontWeight:900,fontSize:'1.1rem'}}>✓</span>}
                      </div>
                    </div>
                    {isBadDay && failedRules.length > 0 && (
                      <div style={{marginTop:'3px',marginLeft:'24px',fontSize:'0.65rem',color:'#b71c1c',background:'#fce4ec',padding:'3px 8px',borderRadius:'4px',borderLeft:'3px solid #c62828'}}>
                        <span style={{fontWeight:700}}>⚠ தவிர்க்க காரணம்: </span>
                        {failedRules.map((chk, ki) => {
                          const def = OONAM_FILTER_DEFS.find(f => f.id === chk.id);
                          return <span key={ki}>{ki > 0 ? ', ' : ''}<b>{def?.label || chk.label}</b>{def?.desc ? ` (${def.desc})` : ''}</span>;
                        })}
                      </div>
                    )}
                    {!isBadDay && (
                      <div style={{marginTop:'3px',marginLeft:'24px',fontSize:'0.62rem',color:'#2e7d32',fontWeight:600}}>✓ அனைத்து சாஸ்திர விதிகளும் பூர்த்தி</div>
                    )}
                  </div>
                  );
                })}
              </div>
              );
            })}

            {/* Varshaaptheekam context for Oonam Apthikam */}
            {varshaBlock && varshaBlock.candidates.length > 0 && (() => {
              const vSel = varshaBlock.candidates.find(c => c.selected);
              if (!vSel) return null;
              const vDate = new Date(vSel.rawDate);
              const oonaBlock = oonamBlocks[3];
              const oonaSel = oonaBlock?.candidates?.find(c => c.selected);
              let shodaDate = new Date(vDate); shodaDate.setDate(shodaDate.getDate() - 1);
              let collision = false;
              if (oonaSel && fmtDate(shodaDate) === oonaSel.engDate) {
                collision = true;
                shodaDate.setDate(shodaDate.getDate() - 1);
              }
              const thadDate = new Date(vDate); thadDate.setDate(thadDate.getDate() + 1);
              return (
                <div style={{background:'#fff3e0',padding:'10px',borderRadius:'8px',border:'1px dashed #ff9800',fontSize:'0.75rem',marginTop:'8px'}}>
                  <div style={{fontWeight:800,color:T.orange,marginBottom:'4px'}}>{'\u{1F4C5}'} வருஷாப்தீகம் தொடர்பான தேதிகள்:</div>
                  <div style={{display:'flex',flexDirection:'column',gap:'3px'}}>
                    <span>{'▸'} ஆப்தீக சோதகும்பம்: <b>{fmtDate(shodaDate)}</b> {collision && <span style={{color:T.danger,fontWeight:700}}>(நகர்த்தப்பட்டது)</span>}</span>
                    <span>{'▸'} வருஷாப்தீகம்: <b style={{color:T.maroon}}>{vSel.engDate}</b></span>
                    <span>{'▸'} ததீயாராதனம்: <b style={{color:'#2e7d32'}}>{fmtDate(thadDate)}</b></span>
                  </div>
                  {collision && <div style={{color:T.danger,fontSize:'0.7rem',marginTop:'4px',fontStyle:'italic'}}>{'⚠️'} ஊன ஆப்தீகம் = வருஷாப்தீக முந்தைய நாள் → சோதகும்பம் ஒரு நாள் முன் நகர்த்தப்படும்</div>}
                </div>
              );
            })()}
          </div>

          <div style={{...cardStyle,borderLeft:'4px solid '+T.greenDk}}>
            <h2 className="oonam-sub-green">● மாஸ்யம் தேதி தேர்வு</h2>
            <p style={{fontSize:'0.75rem',color:'#666',margin:'0 0 12px'}}>ச்ராத்த திதி: <b style={{color:T.greenDk}}>{personPaksham} {personThithiName}</b> — 🔒 = CSV சரிபார்க்கப்பட்டது | ✓ = தானியங்கி</p>
            {masyamBlocks.map((block, bi) => (
              <div key={bi} style={{marginBottom:'14px',background:block.isAdhika?'#e8eaf6':'#f1f8e9',padding:'10px',borderRadius:'8px',border:`1px solid ${block.isAdhika?'#9fa8da':'#c5e1a5'}`}}>
                <div style={{fontWeight:800,color:block.isAdhika?'#283593':T.greenDk,fontSize:'0.9rem',marginBottom:'6px'}}>{block.label} {block.isAdhika && '(அதிக)'}</div>
                {block.candidates.map((c, ci) => (
                  <div key={ci} onClick={()=>selectMasyamCandidate(bi, ci)} style={{
                    padding:'8px',borderRadius:'6px',marginBottom:'5px',cursor:'pointer',
                    background: c.selected ? '#c8e6c9' : '#fff',
                    border: c.selected ? '2px solid '+T.success : '1px solid #eee'
                  }}>
                    <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                      <div style={{display:'flex',alignItems:'center',gap:'6px'}}>
                        <input type="radio" name={`masyam-${bi}`} checked={c.selected} onChange={()=>selectMasyamCandidate(bi, ci)} />
                        <div>
                          <div style={{fontWeight:700,fontSize:'0.8rem',color:T.greenDk}}>
                            {c.source === 'csv' && <span style={{background:'#1b5e20',color:'#fff',padding:'1px 5px',borderRadius:'3px',fontSize:'0.6rem',marginRight:'4px'}}>CSV</span>}
                            {c.engDate} — {c.dayName}
                          </div>
                          <div style={{fontSize:'0.7rem',color:'#666'}}>{c.thithiLabel} | {c.starInfo}</div>
                          {c.dbShradhThithi && <div style={{fontSize:'0.62rem',color:'#1a237e',marginTop:'1px',fontWeight:600}}>Db-ச்ராத்-திதி: {c.dbShradhThithi}</div>}
                        </div>
                      </div>
                      {c.selected && <span style={{color:T.success,fontWeight:900,fontSize:'1.1rem'}}>✓</span>}
                    </div>
                    {c.selectionReason && (
                      <div style={{fontSize:'0.65rem',marginTop:'3px',marginLeft:'24px',color:c.selected?'#388e3c':'#888',fontStyle:'italic'}}>
                        {c.selected ? c.selectionReason : (c.rejectionReason || c.selectionReason)}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            ))}
          </div>

          {varshaBlock && (
            <div style={{...cardStyle,borderLeft:'4px solid '+T.maroon}}>
              <h2 className="oonam-section-head">▣ வருஷாப்தீகம்</h2>
              {varshaBlock.candidates.map((c, ci) => (
                <div key={ci} onClick={()=>selectVarshaCandidate(ci)} style={{
                  display:'flex',justifyContent:'space-between',alignItems:'center',padding:'8px',borderRadius:'6px',marginBottom:'4px',cursor:'pointer',
                  background: c.selected ? '#fce4ec' : '#fff', border: c.selected ? '2px solid '+T.maroon : '1px solid #eee'
                }}>
                  <div>
                    <div style={{fontWeight:700,fontSize:'0.8rem',color:T.maroon}}>{c.engDate} — {c.dayName}</div>
                    <div style={{fontSize:'0.7rem',color:'#666'}}>{c.thithiLabel} | {c.starInfo}</div>
                  </div>
                  {c.selected && <span style={{color:T.maroon,fontWeight:900,fontSize:'1.1rem'}}>✓</span>}
                </div>
              ))}
            </div>
          )}

          <div style={{display:'flex',gap:'8px',marginBottom:'16px'}}>
            <button onClick={()=>setStep('confirm')} style={{...btnPrimary,background:'#999',flex:1}}>◀ பின்</button>
            <button onClick={confirmMasyamsAndGenerate} style={{...btnPrimary,flex:2}}>📋 பட்டியல் உருவாக்கு</button>
          </div>
        </div>
      )}

      {/* ═══════ STEP 4: REVIEW ═══════ */}
      {step === 'review' && (
        <div>
          {/* Person Info Cards */}
          <div style={{display:'flex',gap:'8px',marginBottom:'12px',flexWrap:'wrap'}}>
            <div style={{flex:1,minWidth:'140px',background:'#fffcf5',padding:'10px',borderRadius:'8px',border:'2px solid '+T.maroon}}>
              <div style={{fontWeight:800,color:T.maroon,fontSize:'0.85rem',borderBottom:'1px solid '+T.border,paddingBottom:'4px',marginBottom:'6px'}}>✿ இறந்தவர்</div>
              <div style={{fontSize:'0.8rem'}}><b>பெயர்:</b> {demisedName || '—'}</div>
              {gothram && <div style={{fontSize:'0.8rem'}}><b>கோத்ரம்:</b> {gothram}</div>}
              <div style={{fontSize:'0.8rem'}}><b>தேதி:</b> {fmtDate(deathRecord?.EnglishDate)} — {deathTimeIST}</div>
              <div style={{fontSize:'0.8rem',color:'#1a237e',fontWeight:700,marginTop:'4px'}}><b>ச்ராத்த திதி:</b><br/>{deathTamilYear} - {deathTamilMonth}<br/>{personPaksham} {personThithiName}</div>
            </div>
            <div style={{flex:1,minWidth:'140px',background:'#f8f9fa',padding:'10px',borderRadius:'8px',border:'2px solid #1a237e'}}>
              <div style={{fontWeight:800,color:'#1a237e',fontSize:'0.85rem',borderBottom:'1px solid '+T.border,paddingBottom:'4px',marginBottom:'6px'}}>★ கர்த்தா</div>
              <div style={{fontSize:'0.8rem'}}><b>பெயர்:</b> {karthaName || '—'}</div>
              <div style={{fontSize:'0.8rem'}}><b>நக்ஷத்ர:</b> {karthaStarName}</div>
              {karthaPhone && <div style={{fontSize:'0.8rem'}}><b>Ph:</b> {karthaPhone}</div>}
            </div>
          </div>

          {/* Schedule Table */}
          <div style={{overflowX:'auto',borderRadius:'8px',boxShadow:'0 2px 6px rgba(0,0,0,0.1)',marginBottom:'12px'}}>
            <table style={{width:'100%',borderCollapse:'collapse',fontSize:'0.75rem',minWidth:'500px'}}>
              <thead>
                <tr style={{background:'linear-gradient(135deg,#090b72,#1a237e)',color:'#fff'}}>
                  <th style={{padding:'8px',border:'1px solid #0d1580',textAlign:'center',color:'#d4af37',fontWeight:900}}>#</th>
                  <th style={{padding:'8px',border:'1px solid #0d1580',color:'#d4af37',fontWeight:900}}>விபரம்</th>
                  <th style={{padding:'8px',border:'1px solid #0d1580',color:'#d4af37',fontWeight:900}}>தேதி — கிழமை</th>
                  <th style={{padding:'8px',border:'1px solid #0d1580',color:'#d4af37',fontWeight:900}}>திதி</th>
                  <th style={{padding:'8px',border:'1px solid #0d1580',color:'#d4af37',fontWeight:900}}>நக்ஷத்ர</th>
                  <th style={{padding:'8px',border:'1px solid #0d1580',color:'#d4af37',fontWeight:900}}>குறிப்பு</th>
                </tr>
              </thead>
              <tbody>
                {schedule.map((r, i) => {
                  const bg = r.type === 'oonam' ? '#fff3e0' : r.type === 'thadhi' ? '#e8f5e9' : r.type === 'special' ? '#fce4ec' : r.type === 'adhika' ? '#e8eaf6' : (i % 2 ? '#fafafa' : '#fff');
                  return (
                    <tr key={i} style={{background:bg}}>
                      <td style={{padding:'6px',border:'1px solid #eee',textAlign:'center',fontWeight:700}}>{r.slNo}</td>
                      <td style={{padding:'6px',border:'1px solid #eee',fontWeight:700,color:r.type==='oonam'?T.orange:r.type==='thadhi'?'#2e7d32':r.type==='special'?T.maroon:T.greenDk}}>{r.label}</td>
                      <td style={{padding:'6px',border:'1px solid #eee',fontWeight:600}}>{r.engDate}<br/><span style={{fontWeight:400,color:'#555'}}>{r.dayName}</span></td>
                      <td style={{padding:'6px',border:'1px solid #eee',fontSize:'0.7rem'}}>{r.thithiInfo}</td>
                      <td style={{padding:'6px',border:'1px solid #eee',fontSize:'0.7rem'}}>{r.starInfo}</td>
                      <td style={{padding:'6px',border:'1px solid #eee',fontSize:'0.7rem',color:T.orange}}>{r.notes}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          {/* Standard Note */}
          <div style={{background:'#fff8e1',padding:'10px',borderRadius:'8px',borderLeft:'4px solid #f9a825',fontSize:'0.8rem',color:'#5d4037',marginBottom:'12px'}}>✎ {STANDARD_NOTE}</div>
          {specialNotes && <div style={{fontSize:'0.8rem',color:T.maroon,fontStyle:'italic',marginBottom:'12px'}}>✎ குறிப்பு: {specialNotes}</div>}

          {/* Dharma Sookshmam Disclaimer */}
          <div style={{background:'#fce4ec',padding:'12px',borderRadius:'8px',border:'1px solid #ef9a9a',marginBottom:'12px',fontSize:'0.75rem',lineHeight:1.6,color:'#4e342e'}}>
            <div style={{fontWeight:800,color:T.maroon,fontSize:'0.85rem',marginBottom:'6px'}}>⚠️ முக்கிய அறிவிப்பு</div>
            <p style={{margin:'0 0 6px'}}>இந்த தேதிகள் சாஸ்திர விதிகளின்படி AI உதவியுடன் தானியங்கி முறையில் கணக்கிடப்பட்டவை. CSV சரிபார்க்கப்பட்ட தேதிகள் (🔒) அதிக நம்பகத்தன்மை கொண்டவை.</p>
            <p style={{margin:'0 0 6px'}}>எனினும், <b>தர்ம சூக்ஷ்மம்</b> காரணமாக அரிதாக ஒரு விதிவிலக்கு அல்லது நுண்ணிய சாஸ்திரக் காரணம் இந்த தானியங்கி தேர்வை பாதிக்கக்கூடும். எனவே, உங்கள் குருவிடம் அல்லது அனுபவமுள்ள வாத்யாரிடம் ஒருமுறை சரிபார்த்துக்கொள்ளவும்.</p>
            <p style={{margin:0,fontWeight:700,color:T.maroon}}>இறுதி முடிவு தங்களுடையது.</p>
          </div>

          {/* Action Buttons */}
          <div style={{display:'flex',gap:'8px',flexWrap:'wrap',marginBottom:'8px'}}>
            <button onClick={() => {
              const html = buildPdfHtml(schedule, demisedName, gothram, deathRecord?.EnglishDate, `${deathTimeHour}:${String(deathTimeMinute).padStart(2,'0')} ${deathTimePeriod}`, personPaksham, personThithiName, deathTamilMonth, deathTamilYear, karthaName, karthaStarName, karthaPhone, karthaAddress, specialNotes);
              const printWin = window.open('', '_blank', 'width=800,height=600');
              printWin.document.write(html);
              printWin.document.close();
              printWin.focus();
              setTimeout(() => { printWin.print(); }, 500);
            }} style={{flex:2,minWidth:'150px',background:'linear-gradient(135deg,#090b72,#1a237e)',color:'#d4af37',border:'2px solid #d4af37',padding:'12px',borderRadius:'10px',fontWeight:900,cursor:'pointer',fontSize:'0.95rem',display:'flex',alignItems:'center',justifyContent:'center',gap:'6px'}}>
              🖨️ Print / Save as PDF
            </button>
          </div>
          <div style={{display:'flex',gap:'8px',flexWrap:'wrap',marginBottom:'12px'}}>
            <button onClick={shareWhatsApp} style={{flex:1,minWidth:'120px',background:'#25D366',color:'#fff',border:'none',padding:'10px',borderRadius:'8px',fontWeight:700,cursor:'pointer',fontSize:'0.9rem'}}>WhatsApp</button>
            <button onClick={copyToClipboard} style={{flex:1,minWidth:'120px',background:'#757575',color:'#fff',border:'none',padding:'10px',borderRadius:'8px',fontWeight:700,cursor:'pointer',fontSize:'0.9rem'}}>📋 Copy</button>
          </div>
          <div style={{display:'flex',gap:'8px'}}>
            <button onClick={()=>setStep('masyam-select')} style={{...btnPrimary,background:'#999',flex:1}}>◀ தேதி மாற்ற</button>
            <button onClick={resetForm} style={{...btnPrimary,background:T.maroon,flex:1}}>🔄 புதியது</button>
          </div>
        </div>
      )}

      {/* ═══════ COMMENTS / FEEDBACK SECTION ═══════ */}
      <div style={{background:'#fff',borderRadius:'12px',padding:'16px',marginTop:'16px',boxShadow:'0 2px 8px rgba(0,0,0,0.08)'}}>
        <h2 className="oonam-section-head">💬 கருத்து / Feedback</h2>
        
        {/* Name + comment input */}
        <div style={{marginBottom:'14px'}}>
          <input value={commentName} onChange={e=>setCommentName(e.target.value)} placeholder="உங்கள் பெயர் / Your Name" style={{width:'100%',padding:'8px 10px',borderRadius:'8px',border:'1px solid #ccc',fontSize:'0.85rem',boxSizing:'border-box',marginBottom:'6px'}} />
          <textarea value={newComment} onChange={e=>setNewComment(e.target.value)} placeholder="உங்கள் கருத்தை எழுதவும் / Write your feedback..." rows={3} style={{width:'100%',padding:'10px',borderRadius:'8px',border:'1px solid #ccc',fontSize:'0.85rem',boxSizing:'border-box',resize:'vertical'}} />
          <button onClick={postComment} disabled={!newComment.trim() || !commentName.trim()} style={{marginTop:'6px',padding:'8px 20px',background:T.greenDk,color:'#fff',border:'none',borderRadius:'6px',fontWeight:700,cursor:'pointer',fontSize:'0.85rem',opacity:(!newComment.trim()||!commentName.trim())?0.5:1}}>
            📨 கருத்து அனுப்பு
          </button>
        </div>

        {/* Comments list */}
        {comments.length === 0 && <div style={{fontSize:'0.8rem',color:'#999',textAlign:'center',padding:'20px'}}>இன்னும் கருத்துகள் இல்லை. முதல் கருத்தை நீங்கள் எழுதுங்கள்! 🙏</div>}
        {comments.map(c => (
          <div key={c.id} style={{background:'#f9f9f9',borderRadius:'8px',padding:'10px',marginBottom:'8px',borderLeft:'3px solid '+T.greenDk}}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'4px'}}>
              <div>
                <span style={{fontWeight:700,fontSize:'0.8rem',color:T.maroon}}>{c.user_name}</span>
                <span style={{fontSize:'0.6rem',color:'#999',marginLeft:'8px'}}>{new Date(c.created_at).toLocaleString('ta-IN')}</span>
              </div>
              <button onClick={()=>{setReplyingTo(replyingTo===c.id?null:c.id);setReplyText('');}} style={{background:'none',border:'none',color:'#1565c0',cursor:'pointer',fontSize:'0.7rem',fontWeight:600}}>↩ பதில்</button>
            </div>
            <div style={{fontSize:'0.8rem',color:'#333',whiteSpace:'pre-wrap'}}>{c.message}</div>

            {/* Replies */}
            {c.replies && c.replies.length > 0 && (
              <div style={{marginTop:'8px',marginLeft:'16px',borderLeft:'2px solid #e0e0e0',paddingLeft:'10px'}}>
                {c.replies.map(r => (
                  <div key={r.id} style={{background:'#fff',borderRadius:'6px',padding:'6px 8px',marginBottom:'4px'}}>
                    <span style={{fontWeight:700,fontSize:'0.7rem',color:T.orange}}>{r.user_name}</span>
                    <span style={{fontSize:'0.55rem',color:'#999',marginLeft:'6px'}}>{new Date(r.created_at).toLocaleString('ta-IN')}</span>
                    <div style={{fontSize:'0.75rem',color:'#444',marginTop:'2px'}}>{r.message}</div>
                  </div>
                ))}
              </div>
            )}

            {/* Reply input */}
            {replyingTo === c.id && (
              <div style={{marginTop:'8px',marginLeft:'16px',display:'flex',gap:'6px'}}>
                <input value={replyText} onChange={e=>setReplyText(e.target.value)} placeholder="பதில் எழுதுக..." onKeyDown={e=>e.key==='Enter' && postReply(c.id)} style={{flex:1,padding:'6px 8px',borderRadius:'6px',border:'1px solid #ccc',fontSize:'0.8rem'}} />
                <button onClick={()=>postReply(c.id)} disabled={!replyText.trim()} style={{padding:'6px 12px',background:T.greenDk,color:'#fff',border:'none',borderRadius:'6px',fontWeight:700,cursor:'pointer',fontSize:'0.75rem',opacity:(!replyText.trim())?0.5:1}}>↩</button>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Footer */}
      <div style={{textAlign:'center',fontSize:'0.7rem',color:'#999',marginTop:'20px',paddingBottom:'20px'}}>❀ ஸ்ரீ பரந்தாமன் பஞ்சாங்கம் — Panchanga Service</div>
    </div>
  );
};

export default FullOonamListPage;